const state = {
  topRightComponent: null,
  menuItemBubbleContentComponent: null,
  menuItemBubbleLabelComponent: null,
  mainBubbleContentComponent: null
}

export default state
